import React,{ Component } from 'react';
import Vas from  '../Vas';
import '../css/SideNavigationOffline.css';
import $ from 'jquery';

class SideNavigationOffline extends Component
{
    componentDidMount()
    {
        let me = this;
        let body = $("body");
        //body.css("background-color", "white");
        body.bind("click",function(){
            let burgerMenuClick = localStorage.getItem("BurgerMenu","BurgerMenu");

            if (burgerMenuClick !== "BurgerMenu")
                {document.getElementById("mySidenavOffline").style.width = "0";}
            else
                {localStorage.setItem("BurgerMenu","");}
           me.setState({});
        });

        $(document).keyup(function(e){

            if (e.which === 27){
                if ($("#mySidenavOffline").length>0)
                    {document.getElementById("mySidenavOffline").style.width = "0";}

            }
        });

        let burgerMenu = $("#Menu");
        //body.css("background-color", "white");        
        burgerMenu.bind("click",function(){

            if (document.getElementById("mySidenavOffline").style.width === "" || document.getElementById("mySidenavOffline").style.width === "0px")
            {
                document.getElementById("mySidenavOffline").style.width = "auto";
                localStorage.setItem("BurgerMenu","BurgerMenu");
            }   
            me.setState({});
        });
    }

    render(){
      
        return (<div
          id="mySidenavOffline"
          className="SideNavOffline">
          <table>
            <tbody>
              <tr>
                <td style={{ width:"50px" }}><img
                  src={document.location.origin +"/images/DBLogo.png"}
                  alt={"Systemtechnik_Logo"}
                  style={{ float: 'left', marginRight: '40px' }} /></td>
              </tr>
              <tr>
                <td
                  id="OrderSchoolTicket"
                  className={"linkMenue"}
                  onClick={()=>{ Vas.GetView("Order", null, false); }}>
                    {Vas.Resources.Menus["OrderSchoolTicket"]}
                </td>
              </tr>
              <tr>
                <td
                  id="Login"
                  className={"linkMenue"}
                  onClick={()=>{ Vas.GetView("Login",null, false); }}>{Vas.Resources.Menus["Login"]}
                </td>
              </tr>
              <tr>
                <td
                  id="Impressum"
                  className={"linkMenue"}
                  onClick={()=>{ Vas.GetView("Impressum",null, false); }}>{Vas.Resources.Menus["Impressum"]}
                </td>
              </tr>
            </tbody>
          </table>
        </div>);
    }
}
export default SideNavigationOffline;
